// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1758f174","239":"a5576c7c","455":"b4874f64"}[chunkId] + ".chunk.js";
};